"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = transformUkPhoneNumber;
var _startsWith = _interopRequireDefault(require("lodash/startsWith"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function transformUkPhoneNumber(phoneNumber) {
  var transformedPhoneNumber = phoneNumber;
  if ((0, _startsWith["default"])(phoneNumber, '+44')) {
    transformedPhoneNumber = phoneNumber.replace(/^\+44/, '0');
  }
  return transformedPhoneNumber;
}